import { useCallback, useMemo } from 'react';

import {
  useFetch,
  useMutation,
  useDataRefId,
} from '@bingads-webui-react/overreact';

import { environmentLookupFn } from '../../../../../../env/env-instance';
import { fetchSpec, actionSpec } from '../../__specs/calls/action-spec';

import { dataRefIdDecorator } from './hook-decorators';

export function usePostABTestingFlightLog(variables, config = {}) {
  const { locator } = variables;
  const dataRefId = useDataRefId(dataRefIdDecorator(), environmentLookupFn);

  const defaultConfig = useMemo(() => ({
    mutation: config.mutation || {},
    fetch: config.fetch || {},
  }), [config]);

  const { fetch: fetchConfig, mutation: mutationConfig } = defaultConfig;

  const fetch = useFetch(dataRefId, fetchSpec, locator, fetchConfig);
  const action = useMutation(dataRefId, actionSpec, mutationConfig);

  const callFn = useCallback((param = {}, requestConfig, ...rest) => {
    action(
      {
        ...variables,
        ...param.variables,
      },
      param.payload,
      requestConfig,
      ...rest
    );
  }, [variables, action]);

  const [data, error] = fetch;

  return [{ data, error }, { callFn }];
}
